import React, { useMemo, useState } from "react";
import { ActivityFeed } from "@ofqual/portal-activity-feed";
import { buildDefinitions } from "./buildDefinitions";
import { EntityDialog, DialogType } from "./types";
import { RenderDialog } from "./RenderDialog";
import { ContactTheRegulator } from "../../../domain/ContactTheRegulator";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import { UserType } from "../../../redux/types";
import { ActivityType } from "../../../domain/ActivityType";
import { authSelector } from "../../../redux/selectors";

type CtrActivityFeedProps = {
  contactTheRegulator: ContactTheRegulator;
};

export const CtrActivityFeed: React.FC<CtrActivityFeedProps> = ({
  contactTheRegulator,
}) => {
  const [focussedEntity, setFocussedEntity] = useState<EntityDialog | null>(
    null
  );
  const { userType } = useAuth(authSelector);

  const definitions = buildDefinitions((activity) => {
    setFocussedEntity({
      dialogType: DialogType.ActivityAction,
      focussedActivity: activity,
    });
  }, contactTheRegulator);

  const defaultExcludeActivityTypes = useMemo(() => {
    switch (userType) {
      case UserType.AO:
        return {
          excludeActivityTypes: [
            ActivityType.CtrAssignedOfqual,
            ActivityType.CtrAssignedCcea,
          ],
        };
      case UserType.Ofqual:
        return { excludeActivityTypes: [ActivityType.CtrAssignedCcea] };
      case UserType.CCEA:
        return { excludeActivityTypes: [ActivityType.CtrAssignedOfqual] };
    }
  }, [userType]);

  return (
    <>
      <ActivityFeed
        resourceId={contactTheRegulator.id}
        definitions={definitions}
        params={defaultExcludeActivityTypes}
        actions={[
          {
            label: "Send Message",
            dataTest: "send-message",
            action: () =>
              setFocussedEntity({
                dialogType: DialogType.SendMessage,
              }),
            disabled: !!contactTheRegulator.closedByUpn,
          },
        ]}
      />
      <RenderDialog
        focussedEntity={focussedEntity}
        onClose={() => setFocussedEntity(null)}
        contactTheRegulator={contactTheRegulator}
      />
    </>
  );
};
